import React from 'react';
import { FormGroup, FormSelect } from '@spotify-internal/encore-creator-web';
import { Country } from '../../../types';
import partition from 'lodash/partition';

const HighlightedCountries = ['US', 'SE', 'DE', 'GB'];

interface Props {
  countries: Country[];
  value: string;
  onChange(country: Country): void;
}

export function CountryField(props: Props) {
  function handleOnChange(event: React.ChangeEvent<HTMLSelectElement>) {
    const code = event.target.value;
    const selectedCountry = props.countries.find(country => country.code === code)!;
    props.onChange(selectedCountry);
  }

  const [head, tail]: [Country[], Country[]] = partition(props.countries, (country: Country) =>
    HighlightedCountries.includes(country.code),
  );

  return (
    <>
      <FormGroup label="Where your podcast is made" labelFor="country" indicator="required">
        <FormSelect
          id="country"
          data-testid="country"
          onChange={handleOnChange}
          value={props.value}
        >
          <option value="" disabled>
            Select country
          </option>
          {head.map(country => (
            <option key={country.code} value={country.code}>
              {country.name}
            </option>
          ))}
          <option disabled>────────</option>
          {tail.map(country => (
            <option key={country.code} value={country.code}>
              {country.name}
            </option>
          ))}
        </FormSelect>
      </FormGroup>
    </>
  );
}
